// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1AK0M","content":"styles_content__1Vt0U","checkbox":"styles_checkbox__d5wOj","checkboxLabel":"styles_checkboxLabel__1mzi4"};